import { ca } from '@cian/analytics';

export const trackNewbuildingLayoutOffersListingClick = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Layout',
    action: 'click_sopr',
    label: 'modal_open_listing_jk',
  });
};
